import React, { useContext } from 'react'

import BedbankBaseBookmarkButton from './BedbankBaseBookmarkButton'
import HotelBaseBookmarkButton from './HotelBaseBookmarkButton'

import { getDatesAndGuestsFromOfferPageState } from 'components/OfferPage/utils'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { isLEHotel } from 'lib/offer/offerTypes'
import type { BookmarkDatesAndOccupancy } from 'tripPlanner/types/tripItem'
import type BaseBookmarkButton from '../Common/BaseBookmarkButton'

interface HotelBookmarkButtonProps extends Utils.PropsWithDataAttributes {
  offer:
    | App.HotelOffer
    | App.HotelOfferSummary
    | App.BedbankOffer
    | App.BedbankOfferSummary
  roomTypeId?: string
  withLabel?: React.ComponentProps<typeof BaseBookmarkButton>['withLabel']
  size?: React.ComponentProps<typeof BaseBookmarkButton>['size']
}

const getDatesAndGuests = (
  offerPageState: OfferPageState | undefined,
  globalSearchState: GlobalSearchState | undefined,
): BookmarkDatesAndOccupancy => {
  if (offerPageState) {
    return getDatesAndGuestsFromOfferPageState(offerPageState)
  }
  if (globalSearchState) {
    return {
      checkInDate: globalSearchState.checkinDate,
      checkOutDate: globalSearchState.checkoutDate,
      occupancies: globalSearchState.occupancies,
      durationInDays:
        globalSearchState.checkoutDate && globalSearchState.checkinDate ?
            globalSearchState.checkoutDate.diff(
              globalSearchState.checkinDate,
              'day',
            ) :
          undefined,
    }
  }

  return {}
}

function HotelBookmarkButton({
  offer,
  roomTypeId,
  withLabel,
  size,
  ...rest
}: HotelBookmarkButtonProps) {
  const offerPageState = useContext(OfferPageStateContext)

  const globalSearchState = useContext(GlobalSearchStateContext)
  const datesAndGuests = getDatesAndGuests(offerPageState, globalSearchState)

  if (isLEHotel(offer)) {
    return (
      <HotelBaseBookmarkButton
        {...rest}
        offer={offer}
        datesAndGuests={datesAndGuests}
        roomTypeId={roomTypeId}
        withLabel={withLabel}
        size={size}
      />
    )
  } else {
    return (
      <BedbankBaseBookmarkButton
        {...rest}
        offer={offer}
        datesAndGuests={datesAndGuests}
        roomTypeId={roomTypeId}
        withLabel={withLabel}
        size={size}
      />
    )
  }
}

export default HotelBookmarkButton
